module.exports = __webpack_public_path__ + "img/zeroThree.01471bc7.png";